import { FilterX, Inbox } from "lucide-react";

/**
 * "Nothing exists here" and "your filters excluded everything" are different
 * situations that used to share one line of copy and offer no way out. The second
 * one is recoverable, so it says so and carries the recovery.
 */
export function TableEmpty({ columns, filtered, emptyMessage, onClear }: {
  columns: number;
  /** True when a search or filter is narrowing the table. */
  filtered: boolean;
  /** Copy for the genuinely-no-data case. */
  emptyMessage: string;
  onClear?: () => void;
}) {
  return <tr>
    <td className="empty-cell" colSpan={columns}>
      <span className="empty-state">
        {filtered ? <FilterX size={22} aria-hidden="true" /> : <Inbox size={22} aria-hidden="true" />}
        <strong>{filtered ? "No results for these filters" : emptyMessage}</strong>
        {filtered ? <span>Every record was excluded by the current search or filters.</span> : null}
        {filtered && onClear ? <button type="button" className="secondary-button" onClick={onClear}>Clear filters</button> : null}
      </span>
    </td>
  </tr>;
}
